import { Component, OnInit } from '@angular/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'embryo-CollectionGallery',
  templateUrl: './CollectionGallery.component.html',
  styleUrls: ['./CollectionGallery.component.scss'],
})
export class CollectionGalleryComponent implements OnInit {
  lang: any;
  constructor(public embryoService: EmbryoService) {
    this.embryoService.emitLang.subscribe((lang: any) => {
      this.lang = lang;
    });
  }

  ngOnInit() {}
}
